// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[data-v-91c12394]{border:1px solid var(--secondary-color);background-color:#fff;font-size:11.2px;padding:8px;width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;padding-right:24px}.icon[data-v-91c12394]{position:absolute;right:32px;margin-top:8px}.select-css[data-v-91c12394]::-ms-expand{display:none}", ""]);
// Exports
module.exports = exports;
